import React from "react";
import { Box } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import useStyles from "./styles";

function InvoiceSummarySkeleton() {
  const styles = useStyles();

  return (
    <Box className={styles.invoiceContainer}>
      {/* Invoice Title */}
      <Box width="100%">
        <Skeleton variant="text" width="60%" height={30} />
      </Box>

      {/* Payment Type Field */}
      <Box className={styles.invoiceField}>
        <Skeleton variant="text" width="30%" height={25} />
        <Skeleton variant="text" width="40%" height={30} />
      </Box>

      {/* Property Field with icons */}
      <Box className={styles.invoiceField}>
        <Skeleton variant="text" width="25%" height={25} />
        <Skeleton variant="text" width="50%" height={30} />
        <Box style={{ display: "flex", alignItems: "center", gap: "8px", marginTop: "4px" }}>
          <Box style={{ display: "flex", alignItems: "center", gap: "4px" }}>
            <Skeleton variant="rect" width={24} height={24} style={{ borderRadius: "4px" }} />
            <Skeleton variant="text" width={20} height={16} />
          </Box>
          <Skeleton variant="circle" width={6} height={6} />
          <Skeleton variant="text" width={60} height={16} />
        </Box>
      </Box>

      {/* Amount Field */}
      <Box className={styles.invoiceField}>
        <Skeleton variant="text" width="20%" height={30} />
        <Skeleton variant="text" width="35%" height={30} />
      </Box>

      {/* Due Date Field with Remaining Amount */}
      <Box className={styles.invoiceField}>
        <Skeleton variant="text" width="25%" height={30} />
        <Skeleton variant="text" width="40%" height={30} />
        <Skeleton variant="text" width="45%" height={30} style={{ marginTop: "4px" }} />
      </Box>

      {/* Status Badge */}
      <Box style={{ marginTop: "16px" }}>
        <Skeleton 
          variant="rect" 
          width={80} 
          height={28} 
          style={{ borderRadius: "14px" }} 
        />
      </Box>
    </Box>
  );
}

export default InvoiceSummarySkeleton;
